import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { formatDistanceStrict, isValid, parseISO } from 'date-fns';

import { buildExplorationUrl } from '@/explore/utils/url';
import { Tooltip } from '@/components/tooltip';
import { getCleanedExplorationName } from '@/core/exploration';

import styles from './sidebar-layout.module.scss';

interface User {
  email: string;
}

export interface NavItemProps {
  item: {
    explorationId: string;
    name: string;
    description?: string | null;
    createdAt?: string;
    createdBy?: User;
    updatedAt?: string;
    updatedBy?: User;
  };
  isSavedExploration?: boolean;
  activeExplorationSourceId: string | null;
  buildAccountUrl: (path: string) => string;
  onNavClick: () => void;
}

export function NavItem({
  item,
  isSavedExploration = false,
  activeExplorationSourceId,
  buildAccountUrl,
  onNavClick,
}: NavItemProps) {
  const relativeUpdatedAt =
    item.updatedAt !== undefined && isValid(parseISO(item.updatedAt))
      ? formatDistanceStrict(new Date(item.updatedAt), new Date(), { addSuffix: true })
      : undefined;
  const formattedName = getCleanedExplorationName(item.name);
  const tooltipContent = (
    <>
      <div className={styles.sidebarTooltipTitle}>{formattedName}</div>
      <div className={styles.sidebarTooltipContent}>{item.description}</div>
      {relativeUpdatedAt !== undefined && (
        <p style={{ fontSize: '10px' }}>Updated {relativeUpdatedAt}</p>
      )}
    </>
  );

  return (
    <Tooltip content={tooltipContent} placement="right">
      <NavLink
        to={buildAccountUrl(buildExplorationUrl(item))}
        className={({ isActive }) =>
          classnames(styles.sidebarListing, {
            [styles.active]:
              isActive || (isSavedExploration && item.explorationId === activeExplorationSourceId),
          })
        }
        onClick={onNavClick}>
        {formattedName}
      </NavLink>
    </Tooltip>
  );
}
